'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherMonitor } from '@subframe/core';
import { useAppSelector } from '@/store/hooks';
import { selectAlertasBadge } from '../store/saudeIntegracoes';
interface IntegracaoStatusNavIconProps {
  showDot: boolean;
}
export function IntegracaoStatusNavIcon(t0) {
  const $ = _c(7);
  const {
    showDot
  } = t0;
  const {
    count,
    temCritico
  } = useAppSelector(selectAlertasBadge);
  const dotColor = temCritico ? "bg-error-500" : "bg-warning-500";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherMonitor />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== count || $[2] !== dotColor || $[3] !== showDot) {
    t2 = showDot && count > 0 ? <span className={`absolute -top-1 -right-1 h-2 w-2 rounded-full ${dotColor}`} /> : null;
    $[1] = count;
    $[2] = dotColor;
    $[3] = showDot;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="relative flex">{t1}{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}